export function capitalizeWord(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function titleCaseWord(string) {
  return capitalizeWord(string.toLowerCase());
}

// Taken from https://developer.mozilla.org/en-US/docs/Web/Events/resize
export function throttle(type, name, obj) {
  obj = obj || window;
  let running = false;
  const func = () => {
    if (running) {
      return;
    }
    running = true;
    requestAnimationFrame(() => {
      obj.dispatchEvent(new CustomEvent(name));
      running = false;
    });
  };
  obj.addEventListener(type, func);
}
